import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-card-header-row-component',
    template: `
        <div class="cmps-card-header-row-container">
            <div class="cmps-card-header-row-group">
                <cmps-icon
                    *ngIf="isShowingIcon && !isHumanView"
                    svgIcon="__internal:account-circle"
                ></cmps-icon>
                <cmps-icon
                    *ngIf="isShowingIcon && isHumanView"
                    svgIcon="__internal:briefcase-variant"
                ></cmps-icon>
                <h5 class="cmps-card-header-row-header-title">
                    {{ cardHeaderLabel }}
                </h5>
            </div>
            <h6 class="cmps-card-header-row-header-time-period">
                {{ timePeriod }}
            </h6>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardHeaderRowComponent {
    @Input() cardHeaderLabel: string;
    @Input() timePeriod: string;
    @Input() isShowingIcon: boolean;
    @Input() isHumanView: boolean;
}
